import { PAGE_HEADER_HEIGHT, PAGE_HEADER_HEIGHT_EMPHASIZED } from '@/catalog-apps/components/config'
import { cn } from '@/lib/utils'
import type { CSSProperties } from 'react'

export function PageHeader({
  children,
  title,
  description,
  emphasized,
  className,
  titleAction,
}: {
  children?: React.ReactNode
  title?: string | React.ReactNode
  description?: string
  emphasized?: boolean
  className?: string
  titleAction?: React.ReactNode
}) {
  const pageHeaderHeight = emphasized ? PAGE_HEADER_HEIGHT_EMPHASIZED : PAGE_HEADER_HEIGHT

  return (
    <div
      style={{ height: pageHeaderHeight, '--page-header-height': `${pageHeaderHeight}px` } as CSSProperties}
      className={cn(
        'sticky top-0 z-20 flex w-full items-center justify-between gap-10 border-b bg-offwhite/75 py-2 backdrop-blur',
        {
          'justify-end': !title,
        },
        // { 'rounded-lg border-none bg-foreground/75 px-5 pb-2 pt-2 dark:bg-secondary': emphasized },
        { 'border-none bg-foreground/75 px-5 pb-2 pt-2 dark:bg-secondary': emphasized },
        className
      )}
    >
      {typeof title === 'string' ? (
        <div>
          {title && (
            <div className="flex items-center gap-2">
              <h2
                className={cn('whitespace-nowrap text-xl', {
                  'text-2xl font-bold text-background dark:text-foreground': emphasized,
                })}
              >
                {title}
              </h2>
              {titleAction}
            </div>
          )}
          {description && (
            <p
              className={cn('text-xs font-light text-muted-foreground', {
                'text-sm text-background dark:text-foreground': emphasized,
              })}
            >
              {description}
            </p>
          )}
        </div>
      ) : (
        <div className="flex items-center gap-2 backdrop-blur">
          {title}
          {titleAction}
        </div>
      )}
      {emphasized ? (
        // <div className="flex flex-1 items-center justify-between gap-10 rounded-md bg-offwhite px-1.5 py-0.5">
        <div className="flex flex-1 items-center justify-between gap-10 px-1.5 py-0.5">{children}</div>
      ) : (
        children
      )}
    </div>
  )
}
